import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ScrollView, View, Linking} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {DealCard} from 'src/Modules/CommonView';

import {ButtonTile} from 'src/Modules/CommonView/Buttons';
import HomeNearbyGroupFinder from './HomeNearbyGroupFinder';

import Badges from '../../Badges/Badges';

import {HeaderAndCarouselView} from '../../Modules/CommonView/HeaderAndCarouselView';
import {navigationRef} from 'src/Nav/navigationHelpers';
import ContinueHuntCard from '../../Modules/CommonView/ContinueHuntCard';
import {updateHomeState} from '../../Redux/reducers/home.reducer';
import DelayedLoad from '../../Nav/DelayedLoad';
import {cloudFlareOptimizeImage} from '../../Utils/helpers';
import {howToStartAHuntTips} from '../../Utils/huntFunctions';

// cow photo
const memberImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577715_large.jpg',
  ),
};

// bachelorette party confetti
const bachelorettes = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578550_large.jpg',
  ),
};

const HomeActivityList = () => {
  const {height, width} = useWindowDimensionsSafe();
  const dispatch = useDispatch();
  const userPassportId = useSelector(
    (state) => state.user?.info?.activePassportId,
  );

  const hasPressedPrizes = useSelector(
    (state) => state.app_info?.firstVisit?.hasPressedPrizes,
  );

  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const huntsList = useSelector((state) => state.hunts.huntsList);

  const handlePurchasePress = () => {
    navigationRef.navigate('ExplorerPassSubscriptionsListModal');
  };
  // console.log({huntsList});

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: global.color.white1,
        maxHeight: height - 40,
      }}>
      <ScrollView nativeID="homeScroll" testID="homeScroll">
        <ContinueHuntCard
          containerStyle={{
            width: width - 40,
            left: 20,
            marginTop: 0,
            height: 100,
            marginLeft: 0,

            padding: 20,
            marginBottom: 10,
          }}
        />

        <HomeNearbyGroupFinder />
        {playTestState == false && (
          <View
            style={{
              flexWrap: 'wrap',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}>
            <ButtonTile
              imageSource={require('src/Images/joinExplorer.png')}
              handlePress={() => {
                howToStartAHuntTips();
              }}
              label={'How To Start'}
              itemWidth={(width - 60) / 4}
            />

            <ButtonTile
              imageSource={require('src/Images/standardTicketIcon.png')}
              handlePress={() => {
                navigationRef.navigate('PurchaseModal');
              }}
              testID={'getTickets'}
              label={'Get Tickets'}
              itemWidth={(width - 60) / 4}
            />
            <ButtonTile
              imageSource={require('src/Images/happyTrophy.png')}
              handlePress={() => {
                navigationRef.navigate('Community');
                if (!hasPressedPrizes) {
                  navigationRef.navigate('PrizeWheelModal');
                }
              }}
              label={'Daily Prizes/Challenges'}
              itemWidth={(width - 60) / 4}
            />

            <ButtonTile
              imageSource={require('src/Images/brainiac.png')}
              handlePress={() => {
                navigationRef.navigate('SupportModal');
              }}
              label={'Contact Support'}
              itemWidth={(width - 60) / 4}
            />
          </View>
        )}

        <HeaderAndCarouselView
          type={'hunt_card'}
          intialMaxLength={10}
          data={huntsList?.filter((hunt) => hunt.hunt_type != 'inHome')}
          buttonText={'See Map >'}
          buttonPress={() => {
            dispatch(
              updateHomeState({
                homeSearchText: 'Outdoor Scavenger Hunt:',
                homeActiveSearch: 1,
                homeView: 'map',
              }),
            );
          }}
          carouselIndex={0}
          title={'Outdoor Scavenger Hunts!'}
        />
        {!window?.location?.href?.includes?.('isDemo') && (
          <HeaderAndCarouselView
            type={'hunt_card'}
            intialMaxLength={10}
            data={huntsList?.filter(
              (hunt) =>
                hunt.hunt_type == 'inHome' &&
                !hunt?.name?.includes('Office') &&
                !hunt?.name?.includes('Team'),
            )}
            carouselIndex={1}
            buttonText={'See All >'}
            buttonPress={() => {
              dispatch(
                updateHomeState({
                  homeSearchText: 'In Home Scavenger Hunt:',
                  homeActiveSearch: 1,
                }),
              );
            }}
            title={'Indoor Scavenger Hunts'}
          />
        )}

        <DelayedLoad>
          {!userPassportId && !window?.location?.href?.includes?.('isDemo') && (
            <HeaderAndCarouselView
              data={null}
              buttonText={'Learn More >'}
              buttonPress={() => {
                navigationRef.navigate('PuchaseModal', {
                  showMembershipOnly: true,
                });
              }}
              title={'Explorer Membership'}>
              <DealCard
                title={'Unlock Unlimited Activities'}
                description={'Become a member today.'}
                buttonText={'Become A Member'}
                color={global?.color?.orange}
                imageSource={memberImage}
                handlePress={handlePurchasePress}
              />
            </HeaderAndCarouselView>
          )}

          <HeaderAndCarouselView
            title={'Custom Events'}
            carouselIndex={2}
            type={'custom_card'}
            data={[
              {
                name: `Team Building`,
                description:
                  'Put on your next team building event anywhere in the world. Engage your employees with a fun and competitive scavenger hunt adventure, designed to boost morale, increase productivity and promote your core values.',
                // teambuilding dude thumbs up
                image: {
                  uri: cloudFlareOptimizeImage(
                    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578460_medium.jpg',
                  ),
                },
                handlePress: () => {
                  Linking?.openURL(
                    cloudFlareOptimizeImage(
                      'https://www.letsroam.com/team_building_activities?utm_source=lr_app&utm_medium=events_redirect',
                    ),
                  );
                },
              },
              {
                name: 'Join An Existing Event',
                description:
                  'Join an existing custom event made by a coworker, friend with your custom join code.',
                image: {
                  uri: cloudFlareOptimizeImage(
                    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577343_medium.jpg',
                  ),
                },
                handlePress: () => {
                  navigationRef.navigate('JoinHuntModal');
                },
                rightText: 'Join Existing Event',
              },

              {
                name: `Bachelorette Party`,
                description:
                  'You’ve been dreaming about your wedding since you were a little girl. But let’s be real—you’ve also been dreaming about the ultimate bachelorette party with your besties. Book an epic Bachelorette Scavenger Hunt and leave the party planning to us',
                image: bachelorettes,
                handlePress: () => {
                  Linking?.openURL(
                    'https://www.letsroam.com/bachelorette_scavenger_hunt?utm_source=lr_app&utm_medium=events_redirect',
                  );
                },
              },
              {
                name: `Birthday Party`,
                description:
                  'Make your big day extra special with a custom birthday scavenger hunt. Add custom trivia and more!',

                // kid with camera, taking selfie with family
                image: {
                  uri: cloudFlareOptimizeImage(
                    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578676_medium.jpg',
                  ),
                },
                handlePress: () => {
                  Linking?.openURL(
                    'https://www.letsroam.com/activities/birthday_scavenger_hunt?utm_source=lr_app&utm_medium=events_redirect',
                  );
                },
              },
            ]}
            buttonText={'See All Options >'}
            buttonPress={() => {
              Linking?.openURL(
                'https://www.letsroam.com/team_building_activities?utm_source=lr_app&utm_medium=events_redirect',
              );
            }}
          />
          {!window?.location?.href?.includes?.('isDemo') && (
            <HeaderAndCarouselView
              carouselIndex={3}
              title={'Bar Crawls Scavenger Hunts'}
              type={'hunt_card'}
              intialMaxLength={10}
              data={huntsList?.filter((hunt) => hunt.hunt_type == 'barHunt')}
              buttonText={'See Map >'}
              buttonPress={() => {
                dispatch(
                  updateHomeState({
                    homeSearchText: 'Bar Hunt:',
                    homeActiveSearch: 1,
                    homeView: 'map',
                  }),
                );
              }}
            />
          )}
        </DelayedLoad>
        {playTestState == false &&
          !window?.location?.href?.includes?.('isDemo') && (
            <View>
              <DelayedLoad delay={2000}>
                <HeaderAndCarouselView
                  title={'Refer Friends for Awesome Prizes'}
                  type={'hunt_card'}
                  buttonText={'Refer Friends >'}
                  buttonPress={() => {
                    navigationRef.navigate('ReferralModal');
                  }}
                />
                <Badges showOnlyType={'referral_member_bonus'} />
              </DelayedLoad>
            </View>
          )}

        <View style={{height: 100, width: 100}} />
      </ScrollView>
    </View>
  );
};

export default HomeActivityList;
